<template>
    <div class="error500">
        <div class="error500-body-con">
            <div class="error500-body-con-title">
                5<span class="error500-0-span"><Icon type="social-freebsd-devil"></Icon></span><span class="error500-0-span"><Icon type="social-freebsd-devil"></Icon></span>
            </div>
            <p class="error500-body-con-message">Oops! the server is wrong</p>
            <div class="error500-btn-con">
                <van-button type="info" @click="backPage">返回上一页</van-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Error500',
    methods: {
        backPage () {
            this.$router.go(-1);
        },
    }
};
</script>

<style lang="less">
@keyframes error500animation {
    0% {
        transform: rotateZ(0deg);
    }
    20% {
        transform: rotateZ(-10deg);
    }
    40% {
        transform: rotateZ(5deg);
    }
    60% {
        transform: rotateZ(-5deg);
    }
    80% {
        transform: rotateZ(10deg);
    }
    100% {
        transform: rotateZ(0deg);
    }
}
.error500{
    &-body-con{
        width: 100%;
        height: 100%;
        background-color: #fff;
        bottom: 0;
        position: absolute;
        &-title{
            text-align: center;
            font-size: 2rem;
            font-weight: bold;
            color: #2d8cf0;
            height: 4.4rem;
            line-height: 4.4rem;
            span{
                display: inline-block;
                color: #19be6b;
                font-size: 2rem;
                animation: error404animation 3s ease 0s infinite alternate;
            }
        }
        &-message{
            display: block;
            text-align: center;
            font-size: 0.3rem;
            font-weight: 500;
            letter-spacing: 12px;
            color: #dddde2;
        }
    }
    &-btn-con{
        text-align: center;
        padding: 20px 0;
        margin-bottom: 40px;
    }
}
</style>
